import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { filter } from 'rxjs/operators';
import { AuthSessionService } from './core/services/auth-session.service';
import { FooterComponent } from './layout/footer/footer.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [CommonModule, RouterOutlet, FooterComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  title = 'Senior Screen';
  showFooter = true;

  constructor(
    private readonly authSessionService: AuthSessionService,
    private router: Router
  ) {
    void this.authSessionService;
    this.updateFooterVisibility(this.router.url);

    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.updateFooterVisibility(event.urlAfterRedirects);
      });
  }

  private updateFooterVisibility(url: string): void {
    this.showFooter = !url.startsWith('/login');
  }
}
